import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "country",
        "state"
    ]

    toggleState(event) {
        const countryValue = this.countryTarget.value;
        this.stateTarget.disabled = countryValue === 'FR' || countryValue === '';
    }

}